import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "keyword"]

  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  debounceSearch() {
    if (this.timeout) clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      this.submitForm()
    }, 300)
  }

  filterChanged() {
    this.submitForm()
  }

  submitForm() {
    const form = this.formTarget
    const formData = new FormData(form)
    const params = new URLSearchParams()

    for (const [key, value] of formData.entries()) {
      if (value) params.set(key, value)
    }

    const url = `${form.action}?${params.toString()}`

    // Update browser URL for bookmarkable searches
    window.history.replaceState({}, "", url)

    // Submit via Turbo
    form.requestSubmit()
  }
}
